import type {
  ScheduleSettings,
  UpdateBookingConstraintsRequest,
  UpdateDefaultTemplateRequest,
} from "@/features/calendar/types/schedule-settings.ts";

import { axiosApiInstance } from "@/libs/axios.tsx";
import { API_ENDPOINTS } from "@/constants/api.ts";

export const getScheduleSettings = async () => {
  return axiosApiInstance.get<{ data: ScheduleSettings }>(API_ENDPOINTS.TUTOR.SCHEDULE.SETTINGS);
};

export const updateBookingConstraints = async (data: UpdateBookingConstraintsRequest) => {
  return axiosApiInstance.put<{ data: ScheduleSettings }>(
    API_ENDPOINTS.TUTOR.SCHEDULE.BOOKING_CONSTRAINTS,
    data,
  );
};

export const updateDefaultTemplate = async (data: UpdateDefaultTemplateRequest) => {
  return axiosApiInstance.put<{ data: ScheduleSettings }>(
    API_ENDPOINTS.TUTOR.SCHEDULE.DEFAULT_TEMPLATE,
    data,
  );
};

export const resetGoogleCalendar = async () => {
  return axiosApiInstance.post<{ message: string; tutor_id: string }>(
    API_ENDPOINTS.TUTOR.SCHEDULE.SETTINGS + "/google-calendar/reset",
  );
};
